import BaseClass from "../BaseClass.js";

export default class BackToTop extends BaseClass {

    constructor(element) {
        super(element);

        this.init();
    }

    init() {
        let mySelf = this;

        this.contentScrolledListener = function () {
            mySelf.trackWindowScroll();
        };

        $(document).on('content:scrolled', this.contentScrolledListener);
        this.$element.on('click', () => this.backToTop());
        this.trackWindowScroll();
    }

    trackWindowScroll() {
        if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
            this.$element.css('display', 'block');
        } else {
            this.$element.css('display', 'none');
        }
    }

    backToTop() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }
}